<template>
  <div id="ScoreAdjustmentApplication">
    <ots-main-title :mainTopBtn="mainTopBtn"></ots-main-title>
    <!-- 
      :isDisabledMultiple="isDisabledMultiple"
      @handleSelectionChange="bachOper"
      :tableOption="tableOption"
     -->
    <ots-table-group-new
      ref="ots-table"
      :selectList="selectList"
      :requestForm="requestForm"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="showDialog" title="查看申请材料" width="40%">
      <template v-slot:content>
        
      </template>
      <template v-slot:footer>
        <el-button round @click="showDialog = false">取消</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 申请 -->
    <ots-custom-dialog :dialog.sync="submitDialog" title="申请" width="60%">
      <template v-slot:content>
        <div class="submitTitle">
          <p>学生姓名：{{applySubmitForm.scoreModifyOrderVo.realName}}</p>
          <p>准考证号：{{applySubmitForm.scoreModifyOrderVo.entranceCode}}</p>
          <p>身份证号：{{applySubmitForm.scoreModifyOrderVo.cardNo}}</p>
        </div>
        <div class="submitTitle_2">
          <p>考试批次：{{applySubmitForm.scoreModifyOrderVo.planName}}</p>
          <p>课程名称：{{applySubmitForm.scoreModifyOrderVo.courseName}}</p>
          <p>考试状态：{{applySubmitForm.scoreModifyOrderVo.checkState}}</p>
        </div>
        <el-table :data="applySubmitForm.subCourseList" style="width: 70%; margin: 16px auto;">
          <el-table-column
            prop="subCourseName"
            label="单科目">
          </el-table-column>
          <el-table-column
            prop="score"
            label="单科满分">
          </el-table-column>
          <el-table-column
            prop="answerScore"
            label="原成绩">
          </el-table-column>
          <el-table-column prop="targetScore" label="申请修改后成绩" width="260">
            <template slot-scope="scope">
              <el-input v-model="scope.row.targetScore"  placeholder="请输入申请修改的成绩" :disabled="isShowFlag" @input="(v)=>(scope.row.targetScore=v.replace(/[^\d.]/g,''))" ></el-input>
            </template>
          </el-table-column>
        </el-table>

        <div style="width: 70%; margin: 16px auto;">
            <p><span style="color:#fe5958">*&nbsp;</span>成绩修改申请证明材料：（支持 PDF、JPG、JPEG、PNG）</p>
            <ots-upload-file v-model="importForm.file" ref="OtsUploadFile" :update="timer" :httpRequest="handleFormData" style="margin-top: 8px;" v-if="!isShowFlag"/>
            <el-upload
              class="upload-demo"
              action=""
              :on-remove="handleRemove"
              :on-change="handleSuccess"
              :file-list="applySubmitForm.fileList"
              :before-upload="beforeAvatarUpload"
              :http-request="uploadImg"
              list-type="picture"
              >
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.fileext == 'pdf'? defaultUrl: file.url" alt="" style="cursor: pointer;" @click="openFile(file.url)">
                <span class="el-upload-list__item-actions" style="cursor: pointer;" @click="openFile(file.url)">
                  <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                  <span class="el-upload-list__item-preview">
                    {{ file.name }}
                  </span>
                </span>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-check"></i>
                </label>
                <i class="el-icon-close" @click="handleRemove(file, applySubmitForm.fileList)" v-if="!isShowFlag"></i>
              </div>
            </el-upload>
            <p style="margin-top: 16px;">申请备注：</p>
            <el-input type="textarea" v-model="applySubmitForm.scoreModifyOrderVo.applyRemark" :disabled="isShowFlag"></el-input>
        </div>

      </template>
      <template v-slot:footer>
        <el-button round @click="submitDialog = false">取消</el-button>
        <el-button round type="primary" @click="implementApply" v-if="!isShowFlag">确定</el-button>
      </template>
    </ots-custom-dialog>


    <!-- 查看申请材料 -->
    <ots-custom-dialog :dialog.sync="showFileDialog" title="查看申请材料" width="40%">
      <template v-slot:content>
        <div style="width: 70%; margin: 16px auto;">
          <ul class="showFile">
            <li v-for="item in applySubmitForm.fileList" :key="item.id" @click="openApplyFile(item.url)">
              <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showFileDialog = false">关闭窗口</el-button>
      </template>
    </ots-custom-dialog>
      

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanCourseList } from "@/http/modules/custom";
import { getPlaceList } from "@/http/modules/baseSet/examSite";
import { getExamCheckStateFn, applyListAPI, applyExportAPI, applySubmitAPI, applyOrderInfoAPI, uploadFileAPI, applyCancelAPI } from "@/http/modules/examSet/score";
export default {
  data() {
    return {
      // 页头按钮，导出
      mainTopBtn: [
        {
          title: "导出",
          plain: true,
          fn: this.export,
        },
      ],
      // 
      selectList: [
        {
          title: "考试批次",
          isSearch: true,
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号/准考证号",
        },
        {
          title: '课程名称',
          type: 'select',
          requestKey: 'courseId',
          label: 'courseName',
          value: 'courseId',
          data: [],
        },
        {
          title: "考试状态",
          type: "select",
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "stationName",
          value: "stationId",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'placeName',
          value: 'placeId',
          data: [],
        },
        {
          title: "申请状态",
          type: "select",
          requestKey: "applyState",
          label: "name",
          value: "id",
          data: [
            { id: '', name: "全部"},
            { id: -1, name: "未申请" },
            { id: 0, name: "审核不通过" },
            { id: 1, name: "审核通过" },
            { id: 2, name: "待审核" },
            { id: -2, name: "申请已撤销" }
          ]
        }
      ],
      requestForm: {
        planId: "",
        searchKey: "",
        courseId: "",
        checkState: "",
        stationId: "",
        placeId: "",
        applyState: "",
        page: 1,
        size: 10,
      },
      pagination: {
        total: 0,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
          fixed: "left",
          width: "180px"
        },

        {
          title: "学生姓名",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
          width: "180",
          fixed: "left",
        },
        {
          title: "证件号",
          prop: "cardNo",
          fixed: "left",
        },
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "考试状态",
          prop: "checkState",
        },
        {
          title: "分数",
          prop: "score",
        },
        {
          title: "申请状态",
          prop: "applyState"
        },
        {
          title: "申请材料",
          type: "button",
          formatter: (val) => "查看",
          click: this.showFile,
          disableFn: function(scope) {
            return scope.row.fileCount == 0;
          },
          fixed: "right",
        },
        {
          title: "审核备注",
          prop: "auditRemark",
          fixed: "right",
        },
        {
          title: "操作",
          type: "buttons",
          width: "240px",
          fixed: "right",
          btnList: [
            {
              title: function (scope) {
                if (scope.row.cancelStatus == 1) {
                  return "再次提交";
                } else {
                  return "提交申请";
                }
              },
              click: this.submit,
              formatter: this.setSubmitTitle

            },
            {
              title: "编辑",
              click: this.submit,
              formatter: this.setSubmitTitle_2
            },
            {
              title: "撤销申请",
              click: this.revoke,
              formatter: this.setRevokeTitle
            },
            {
              title: "查看",
              // function(scope) {
              //   return scope.row.applyState == "审核通过" ? "查看": "";
              // },
              click: this.show,
              formatter: function(scope) {
                return scope.row.applyState == "未申请";
              },
            },
          ],
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
      },
      batchOperBtn: [
        // {
        //   title: "批量申请成绩修改",
        //   icon: "iconfont icon-bianji",
        //   click: this.batchEdit,
        // },
        // {
        //   title: "查看批量申请记录",
        //   icon: "iconfont icon-kaiqi",
        //   click: this.showBatchRecord
        // },
      ],
      showDialog: false,
      submitDialog: false,
      applySubmitForm: {
        fileList: [],
        scoreModifyOrderVo: {},
        subCourseList: []
      },
      importForm: {
        file: "",
      },
      showFileDialog: false,
      planInfo: {},
      tableFlag: false,
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      isShowFlag: false,
      timer: "",
    }
  },

  watch: {
    "requestForm.planId": async function(planId) {
      await this.getPlanInfo(planId);
      this.getCourseList(planId);
      this.getPlaceList();
      this.getStationList(planId);
      await this.search();
    },
    "requestForm.stationId": async function() {
      this.getPlaceList();
    },
    "submitDialog": function(flag) {
      if (!flag) {
        this.applySubmitForm = {
          fileList: [],
          scoreModifyOrderVo: {},
          subCourseList: []
        }
      }
    }
  },

  mounted() {
    this.initData();
  },

  methods: {
    openFile(url) {
      window.open(url);
    },


    async getStationList(planId) {
      this.requestForm.stationId = "";
      const {data: stationList} = await this.$api.system.getStationsForPlan({planId});
      this.selectList[4].data = [...stationList];
    },

    setRevokeTitle(scope) {
      let { scorePublish } = this.planInfo;
      let { applyState } = scope.row;
      if (scorePublish === 0 && applyState == "待审核") {
        return false;
        // return "撤销申请";
      } else {
        return true;
      }
    },
    setSubmitTitle(scope) {
      // 成绩发布前未申请  || 审核不通过允许再次申请的 ==> 显示“提交申请”
      // scorePublish 1 已发布，0 未发布
      // 成绩发布前  待审核状态的   可以编辑
      let { applyState, allowApplyAgain } = scope.row;
      let { scorePublish } = this.planInfo;

      console.log(scorePublish)

      if ( 
        (scorePublish === 0 && applyState == "未申请") || 
        (scorePublish === 0 && applyState == "审核不通过" && allowApplyAgain === 1) || 
        (scorePublish === 0 && applyState == "申请已撤销") 
      ) {
        return false;
      } else {
        return true;
      }

      return;
      if ( (scorePublish === 0 && applyState == "未申请") || (applyState == "审核不通过" && allowApplyAgain === 1) ) {
        return "提交申请";
      } else if (scorePublish === 0 && applyState == "待审核") {
        return "编辑";
      } else {
        return "";
      }
    },
    setSubmitTitle_2(scope) {
      // 成绩发布前未申请  || 审核不通过允许再次申请的 ==> 显示“提交申请”
      // scorePublish 1 已发布，0 未发布
      // 成绩发布前  待审核状态的   可以编辑
      let { applyState, allowApplyAgain } = scope.row;
      let { scorePublish } = this.planInfo;
      if (scorePublish === 0 && applyState == "待审核") {
        return false;
      } else {
        return true;
      }

      return;
      if ( (scorePublish === 0 && applyState == "未申请") || (applyState == "审核不通过" && allowApplyAgain === 1) ) {
        return "提交申请";
      } else if (scorePublish === 0 && applyState == "待审核") {
        return "编辑";
      } else {
        return "";
      }
    },
    

    // 批次信息
    async getPlanInfo(planId) {
      const {data: planInfo} = await this.$api.applyManage.getCurrentPlan({ planId });
      this.planInfo = planInfo;
      this.tableFlag = true;
    },
    // 初始化数据
    async initData() {
      // 批次下拉
      const { data: planList } = await getSelectPlanFn({needAudit: 14});
      this.selectList[0].data = planList;
      this.requestForm.planId = planList[0].id;
      // 考试状态下拉
      const { data: checkStateList } = await getExamCheckStateFn();
      this.$set(this.selectList[3], "data", checkStateList);
      // 教学点下拉
      const stationList = await this.mixin_getSelectStation();
      this.selectList[4].data = [...stationList];
    },

    // 课程列表下拉
    async getCourseList(value) {
      this.requestForm.courseId = "";
      const { data } = await getPlanCourseList({ planId: value });
      let courseIdList = [{ courseId: "", courseName: "全部" }, ...data];
      this.$set(this.selectList[2], "data", courseIdList);
    },
    // 考点下拉
    async getPlaceList() {
      let params = {
        planId: this.requestForm.planId,
        stationId: this.requestForm.stationId,
      }
      const { data: placeData } = await getPlaceList(params);
      if (!placeData) {
        this.selectList[5].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[5].data = [...placeData];
      this.requestForm.placeId = "";
    },
    // 查询
    async search() {
      this.requestForm.page = 1;
      await this.getTableData();
    },
    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm };
      const { data } = await applyListAPI(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
    // 导出
    async export() {
      let params = { ...this.requestForm };
      const { code, data } = await applyExportAPI(params);
      if (code == 1) {
        window.open(data);
      }
    },
    // 查看
    async show(row) {
      this.getApplyOrderInfo(row);
      this.isShowFlag = true;
      this.submitDialog = true;
    },

    // 查看材料
    showFile(row) {
      this.getApplyOrderInfo(row);
      this.showFileDialog = true;
    },

    // 打开材料
    openApplyFile(val) {
      window.open(val);
    },

    // 编辑
    edit() {

    },
    // 申请 ==> 弹窗
    submit(row) {
      
      this.timer = String(new Date().getTime());

      this.getApplyOrderInfo(row);
      this.isShowFlag = false;
      this.submitDialog = true;
    },

    // 申请 ==> 数据查询
    async getApplyOrderInfo(row) {
      let params = {
        planId: row.planId,
        studentCourseId: row.studentCourseId,
      }
      const { data } = await applyOrderInfoAPI(params);
      this.applySubmitForm = data;
    },


    // 确认申请
    async implementApply() {
      let isConfirm = false;
      let isConfirm_2 = false;
      let courseName = "";
      this.applySubmitForm.subCourseList.map(e=> {
        if (e.targetScore > e.score) {
          isConfirm = true;
        }
        if (e.targetScore != null && e.targetScore != "" && (Number(e.targetScore) === Number(e.answerScore))) {
          isConfirm_2 = true;
          courseName = e.subCourseName;
        }
      })

      if (isConfirm_2) {
          this.$alert(`修改后成绩不能等于原成绩！`, '提示！', {
            confirmButtonText: '确定',
            type: "warning",
          });
          return;
      }

      if (isConfirm) {
        this.$alert('申请修改成绩，不可以超过对应的单科满分！', '提示！', {
          confirmButtonText: '确定',
          type: "warning",
        });
        return;
      }

      if (!this.applySubmitForm.fileList.length) {
        this.$message.error("请提交申请证明材料！");
        return;
      } 

      if (this.applySubmitForm.scoreModifyOrderVo.applyRemark && this.applySubmitForm.scoreModifyOrderVo.applyRemark.length > 100) {
        this.$message.error("申请备注不超过 100 个字符！");
        return;
      }

      let fileIds = this.applySubmitForm.fileList.map(e => {return e.id}).join(",");
      let isManageApply = 0;
      let { orderId, planId, recordId, studentCourseId, applyRemark } = this.applySubmitForm.scoreModifyOrderVo;
      let subCourseList = [];


      this.applySubmitForm.subCourseList.map(e=> {
        let item = {
          courseId: e.courseId,
          subCourseCode: e.subCourseCode,
          modifyType: e.modifyType ? e.modifyType: 0,
          targetScore: e.targetScore
        }
        subCourseList.push(item);
      })


      let subCourseJsonData = JSON.stringify(subCourseList);
      let params = {
        fileIds,
        isManageApply,
        orderId, 
        planId, 
        recordId, 
        studentCourseId,
        subCourseJsonData,
        applyRemark
      }
      const { code } = await applySubmitAPI(params);
      if (code == 1) {
        this.$message.success("申请成功！");
        this.submitDialog = false;
      }
      this.getTableData();
    },

    // 撤销申请
    async revoke(row) {
      this.$confirm("确定要撤销申请吗？", "撤销申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          planId: row.planId,
          orderId: row.orderId,
          cancelRemark: "",
        }
        const { code } = await applyCancelAPI(params);
        if (code) {
          this.$message.success("撤销成功！");
        }
        this.getTableData();
      })
    },

    // 勾选
    bachOper(val) {
      this.stuIds = [];
      let idList = [];
      val.forEach((item) => {
        idList.push(item.stuid);
      });
      this.stuIds = idList;
    },

    // 批量申请成绩修改
    batchEdit() {

    },

    // 查看批量申请记录
    showBatchRecord() {

    },

    // 提交申请 ==> 材料删除
    handleRemove(file, fileList) {
      this.applySubmitForm.fileList = fileList.filter(function(e){
        return e.uid != file.uid;
      });
      this.uploadFile(fileList);
    },
    // 提交申请 ==> 材料添加
    handleSuccess(file, fileList) {
      this.applySubmitForm.fileList = fileList;
      this.uploadFile(fileList);
    },
    // 提交申请 ==> 材料校验
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png", "pdf"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      if(!isJPG) {
        this.$message.error(`申请材料只能是 "PDF", "JPG", "JPEG", "PNG" 格式!`);
      }
      return isJPG
    },
    // 材料上传
    async handleFormData(val) {
      this.importForm.file = val.file;
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      const { code, data } = await uploadFileAPI(fd);
      if (code) {
        this.applySubmitForm.fileList.push(data);
      }
    },
    // 提交申请 ==> 材料处理
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.applySubmitForm.fileList.map((item, index)=> {
            if (item.name == data.file.name) {
              that.applySubmitForm.fileList[index].url = e.currentTarget.result;
            }
          })
        }
      };
    },
    // 提交申请 ==> 材料上传
    async uploadFile(fileList) {

    },

    // 每页数量
    changeNum(num) {
      this.requestForm.size = num;
      this.getTableData();
    },
    // 页码
    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }
}
</script>
<style scoped lang="less">
.submitTitle {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #ccc;
}
.submitTitle_2 {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.submitTitle,.submitTitle_2 {
  &>p{
    width: 32%;
  }
}
.showFile {
  &>li {
    display: flex; 
    align-items: center; 
    margin-top: 16px; 
    border: 1px dashed #CCC; 
    border-radius: 8px;
    cursor: pointer;
    &>img {
      width: 120px; 
      height: 120px;
    }
    &>p{
      margin-left: 16px;
    }
  }
}
</style>
